import React, {
    forwardRef,
    HTMLAttributes,
    ReactElement,
    ReactNode,
} from 'react';
import cn from 'classnames';
import { Notification } from '../../atoms/notification/notification';
import {
    CheckboxProps,
    DropdownProps,
    RadioButtonProps,
    TextAreaProps,
    TextFieldProps,
    ToggleProps,
} from '../../atoms';

export interface FormFieldProps extends HTMLAttributes<HTMLDivElement> {
    // TODO can it be inferred from children?
    fieldType:
        | 'text'
        | 'password'
        | 'textarea'
        | 'radio'
        | 'checkbox'
        | 'dropdown'
        | 'toggle';
    size?: 'quarter' | 'half';
    // TODO maybe as a single notification prop?
    notificationText?: ReactNode;
    notificationType?: 'neutral' | 'success' | 'warning' | 'error';
    children:
        | ReactElement<TextFieldProps>
        | ReactElement<TextAreaProps>
        | ReactElement<RadioButtonProps>
        | ReactElement<CheckboxProps>
        | ReactElement<DropdownProps>
        | ReactElement<ToggleProps>;
}

export const FormField = forwardRef<HTMLDivElement, FormFieldProps>(
    (props, ref) => {
        const {
            fieldType,
            size,
            notificationText,
            notificationType = 'neutral',
            className,
            children,
        } = props;
        const classes = cn(
            'm-form-field',
            {
                'm-form-field--radio': fieldType === 'radio',
                'm-form-field--checkbox': fieldType === 'checkbox',
                'm-form-field--dropdown': fieldType === 'dropdown',
                'm-form-field--toggle': fieldType === 'toggle',
                [`-${size}`]: size,
            },
            className,
        );

        return (
            <div ref={ref} className={classes}>
                {children}
                {notificationText && (
                    <Notification variant="text" type={notificationType}>
                        {notificationText}
                    </Notification>
                )}
            </div>
        );
    },
);
